import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClose", "isOpen", "closeOnOverlayClick", "children", "variantProps", "dataTestId", "hasAutoFocus", "headerStyles"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react';
import { ArrowLeft } from '../../../../assets/icons';
import Icon from '../../../Icon';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function LoginModal(_ref) {
  var onClose = _ref.onClose,
    isOpen = _ref.isOpen,
    closeOnOverlayClick = _ref.closeOnOverlayClick,
    children = _ref.children,
    variantProps = _ref.variantProps,
    dataTestId = _ref.dataTestId,
    _ref$hasAutoFocus = _ref.hasAutoFocus,
    hasAutoFocus = _ref$hasAutoFocus === void 0 ? false : _ref$hasAutoFocus,
    headerStyles = _ref.headerStyles,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var prefix = dataTestId ? "".concat(dataTestId, "-") : '';
  var compModalHeaderStyles = headerStyles ? _objectSpread(_objectSpread({}, modalHeaderStyle), headerStyles) : _objectSpread({}, modalHeaderStyle);
  var compModalFooterStyles = variantProps !== null && variantProps !== void 0 && variantProps.footerStyles ? _objectSpread(_objectSpread({}, modalFooterStyle), variantProps === null || variantProps === void 0 ? void 0 : variantProps.footerStyles) : _objectSpread({}, modalFooterStyle);
  return _jsxs(Modal, _objectSpread(_objectSpread({
    "data-testid": "".concat(prefix, "ChakraModal"),
    scrollBehavior: "inside",
    isOpen: isOpen,
    onClose: onClose
  }, otherProps), {}, {
    autoFocus: hasAutoFocus,
    closeOnEsc: closeOnOverlayClick,
    closeOnOverlayClick: closeOnOverlayClick,
    children: [_jsx(ModalOverlay, {}), _jsxs(ModalContent, _objectSpread(_objectSpread({
      "data-testid": "".concat(prefix, "ModalContent")
    }, modalContentStyle), {}, {
      width: otherProps.size ? 'auto' : {
        mobile: 'full',
        sm: 'auto'
      },
      children: [_jsx(ModalHeader, _objectSpread(_objectSpread({}, compModalHeaderStyles), {}, {
        "data-testid": "".concat(prefix, "ModalHeader"),
        children: variantProps && _jsxs(_Fragment, {
          children: [(variantProps === null || variantProps === void 0 ? void 0 : variantProps.onGoBack) && (variantProps === null || variantProps === void 0 ? void 0 : variantProps.goBackButtonText) && _jsxs(Flex, _objectSpread(_objectSpread({}, modalGoBackBtnStyles), {}, {
            onClick: variantProps.onGoBack,
            "data-testid": "".concat(prefix, "ModalGoBackButton"),
            children: [_jsx(Icon, {
              svg: _jsx(ArrowLeft, {})
            }), _jsx(Text, _objectSpread(_objectSpread({}, modalGoBackTextStyles), {}, {
              children: variantProps.goBackButtonText
            }))]
          })), _jsx(Text, _objectSpread(_objectSpread({}, headerTitleStyle(variantProps === null || variantProps === void 0 ? void 0 : variantProps.title)), {}, {
            "data-testid": "".concat(prefix, "ModalTitle"),
            children: variantProps.title
          }))]
        })
      })), _jsx(Box, _objectSpread({}, delimiterModalStyle)), _jsx(ModalBody, _objectSpread(_objectSpread({
        "data-testid": "".concat(prefix, "ModalBody")
      }, modalBodyStyle), {}, {
        children: _jsx(Box, {
          overflow: "auto",
          maxH: "calc(100vh - 9rem)",
          children: children
        })
      })), (variantProps === null || variantProps === void 0 ? void 0 : variantProps.footer) && _jsx(ModalFooter, _objectSpread(_objectSpread({
        "data-testid": "".concat(prefix, "ModalFooter")
      }, compModalFooterStyles), {}, {
        children: variantProps === null || variantProps === void 0 ? void 0 : variantProps.footer
      }))]
    }))]
  }));
}
var modalBodyStyle = {
  overflow: 'auto',
  p: '0'
};
var modalContentStyle = {
  maxW: 'auto',
  maxH: 'auto',
  overflow: 'auto',
  height: {
    mobile: 'full',
    sm: 'fit-content'
  },
  top: {
    mobile: '0',
    sm: '2.938rem',
    md: '3.75rem',
    xl: '6.375rem'
  },
  my: '0',
  p: 0,
  borderRadius: {
    mobile: '0',
    sm: '0.875rem'
  },
  boxShadow: '0 0.125rem 0.75rem var(--chakra-colors-darkGrey2)'
};
var modalHeaderStyle = {
  minH: 'var(--chakra-space-xxl)',
  display: 'flex',
  alignItems: 'center',
  py: 'sm',
  px: {
    mobile: 'md',
    sm: 'lg'
  }
};
var delimiterModalStyle = {
  mx: {
    mobile: 'md',
    sm: 'lg'
  },
  h: '0.063rem',
  bgColor: 'lightGrey4'
};
var headerTitleStyle = title => {
  return {
    ml: 'xl',
    color: 'darkGrey1',
    justify: 'center',
    justifyContent: 'center',
    fontSize: 'lg',
    lineHeight: '3',
    fontFamily: 'header',
    padding: 0,
    minHeight: title ? 'initial' : '2rem'
  };
};
var modalFooterStyle = {
  justifyContent: 'flex-start',
  overflow: 'auto',
  py: 'sm',
  px: {
    mobile: 'md',
    sm: 'lg'
  }
};
var modalGoBackBtnStyles = {
  alignItems: 'center',
  w: 'fit-content',
  justifyContent: 'flex-start',
  cursor: 'pointer',
  py: '2'
};
var modalGoBackTextStyles = {
  pl: 'sm',
  fontWeight: 'normal',
  fontSize: 'md',
  color: 'darkGrey1',
  lineHeight: '3'
};